import { useQuery } from '@tanstack/react-query';
import { getInsuranceContractByPlant } from '../api';
import { INSURANCE_QUERY_KEY } from '../constants';
import { InsuranceContractByPlantParams } from '../model';

export const useInsuranceContractByPlant = (
  params?: InsuranceContractByPlantParams,
) => {
  return useQuery({
    queryKey: [INSURANCE_QUERY_KEY.CONTRACT_BY_PLANT, params],
    queryFn: () => getInsuranceContractByPlant(params),
    enabled: Boolean(params?.year),
  });
};
